export default {
    'halls.loading': 'Đang tải',
    'halls.primary.title': 'Luyện tập',
    'halls.middle.title': 'Chuyên gia',
    'halls.high.title': 'Cao thủ',
    'halls.top.title': 'Thiên tài',
    'halls.level.describe': 'Điều kiện sảnh',
    'halls.coin.not': 'Không đủ tiền xu',
    'halls.setting.title': 'Cài đặt',
};